import { useEffect, useState } from 'react';
import myimg from '../../assets/img/mypicturew.png'
import { AiOutlineMenu } from "react-icons/ai";
import { FaCss3 } from "react-icons/fa";
import { SiNextdotjs } from "react-icons/si";
import { TbBrandJavascript } from "react-icons/tb";
import { FaReact } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { IoMdAdd } from "react-icons/io";
import { SiTailwindcss } from "react-icons/si";
import { FiMinus } from "react-icons/fi";
import { FaLinkedin } from "react-icons/fa";
import { BsBootstrapFill } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { FaPython } from "react-icons/fa";
import { SiFastapi } from "react-icons/si";
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const history = useHistory();
  const [currentPath, setCurrentPath] = useState(history.location.pathname);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      setCurrentPath(location.pathname);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  const menuHandler = () => {
    setMenuOpen(!menuOpen)
  }
  const handleOpen = () => {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div className='sticky top-0 z-20 w-full px-2 overflow-x-hidden bg-white shadow-md'>
        <div className='md:px-2 xl:px-5 flex items-center justify-between  w-full py-2 text-[#616161]'>

          <Link to='/' className='hover:text-[#212121] hover:no-underline'><div className="flex items-center gap-x-3">
            <img src={myimg} alt='' className='rounded-full h-14 md:h-16' />
            <h6 className='text-2xl font-bold lg:text-3xl'>GULFAMFOLIO</h6>
          </div></Link>
          <div className='flex items-center md:gap-x-3'>
            <ul className='items-center hidden text-sm font-semibold gap-x-4 lg:text-base lg:gap-x-5 nav-content'>
              <li className='border-black cursor-pointer ' ><Link to='/' title='Exlore home' className={`nav-heading hover:no-underline hover:text-[#222222] ${currentPath === '/' ? '' : 'after:w-0'}`}>HOME</Link></li>
              <li className='border-black cursor-pointer ' ><Link to='/about-me' title='Exlore about me' className={`nav-heading hover:no-underline ${currentPath === '/about-me' ? 'after:w-full' : 'after:w-0'} hover:text-[#222222]`}>ABOUT ME</Link></li>
              <li className='border-black cursor-pointer ' ><Link to='/my-projects' title='Exlore my Projects' className={`nav-heading hover:no-underline hover:text-[#222222] ${currentPath === '/my-projects' ? 'after:w-full' : 'after:w-0'}`}>MY PROJECTS</Link></li>
              <li className='border-black cursor-pointer ' ><Link to='/my-team' title='Exlore my team' className={`nav-heading hover:no-underline hover:text-[#222222] ${currentPath === '/my-team' ? 'after:w-full' : 'after:w-0'}`} >MY TEAM</Link></li>
              <li className='border-black cursor-pointer ' ><Link to='/contact-me' className={`nav-heading hover:no-underline hover:text-[#222222] ${currentPath === '/contact-me' ? 'after:w-full' : 'after:w-0'}`} title='Connect with me'>CONTACT ME</Link></li>
            </ul>
            <div className='block p-1 bg-black rounded-md cursor-pointer menu-button '>

              <AiOutlineMenu onClick={menuHandler} size={25} className='text-white' />
            </div>
          </div>
        </div>


      </div>
      {/* menu */}
      <div className={`${menuOpen ? 'right-0' : '-right-[100vh]'} overflow-y-auto  py-4 border-l-2 border-black bg-white fixed z-50 top-0 transition-all duration-300 w-full sm:w-[400px] px-3 h-full flex-col gap-y-24`}>
        <div className="flex justify-end items-center w-full mb-[18px]">

          <RxCross2 onClick={menuHandler} size={36} className="p-1 text-white bg-black rounded-full cursor-pointer " />
        </div>

        <div className="flex flex-col w-full px-2 gap-y-5">

          <Link to='/' onClick={menuHandler} className='hover:text-[#141414]'><h6 className='cursor-pointer  p-1  border font-semibold text-[18px]'>Home</h6></Link>
          <Link to='/about-me' onClick={menuHandler} className='hover:text-[#141414]'><h6 className='cursor-pointer  p-1  border font-semibold text-[18px]'>About Me</h6></Link>
          <Link to='/my-projects' onClick={menuHandler} className='hover:text-[#141414]'><h6 className='cursor-pointer  p-1 border font-semibold text-[18px]'>My Projects</h6></Link>
          <Link to='/my-team' onClick={menuHandler} className='hover:text-[#141414]'><h6 className='cursor-pointer  p-1  border font-semibold text-[18px]'>My Team</h6> </Link>

          <div className={`${isOpen ? 'h-[450px]' : 'h-[36px]'} border flex flex-col transition-all duration-500  p-1  overflow-hidden`}>
            <div onClick={handleOpen} className='flex items-center justify-between font-semibold cursor-pointer'>
              <h6 className='text-[18px]'>My Services</h6>
              {isOpen ? <FiMinus size={25} className='' /> : <IoMdAdd size={25} className='' />}
            </div>

            {/* contain after click */}
            <div className="flex flex-col p-2 mt-2 text-sm gap-y-5">



              <div className='flex flex-col gap-y-2'>
                <h6 className='mb-1 font-semibold'>Front-End Development:</h6>

                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <SiNextdotjs />
                  <h6>Next</h6>
                </div>

                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <FaReact />
                  <h6>React</h6>
                </div>

                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <TbBrandJavascript />
                  <h6>JavaScript</h6>
                </div>

                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <FaCss3 />
                  <h6>CSS</h6>
                </div>

                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <SiTailwindcss />
                  <h6>TailwindCSS</h6>
                </div>

                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <BsBootstrapFill />
                  <h6>Bootstrap</h6>
                </div>

                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <FaReact />
                  <h6>ReactStrap</h6>
                </div>
              </div>
              <div className='flex flex-col gap-y-2'>
                <h6 className='mb-1 font-semibold'>Back-End Development:</h6>
                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <FaPython />
                  <h6>Python</h6>
                </div>

                <div className='flex items-center gap-x-2 cursor-pointer hover:text-[#3B82F6] transition-colors duration-300'>
                  <SiFastapi />
                  <h6>FastAPI</h6>
                </div>
              </div>

              <h6 className='font-semibold'>SEO Ranking</h6>
              <h6 className='font-semibold'>Web Designing</h6>
              <h6 className='font-semibold'>Graphic Designing</h6>




            </div>
          </div>

          <Link to='/contact-me' onClick={menuHandler} className='hover:text-[#141414] '><h6 className='cursor-pointer p-1 text-[18px] border  font-semibold'>Contact Me</h6></Link>
          <div className="flex flex-col p-1 gap-y-1 ">
            <h4 className=" font-semibold mb-3 text-[18px]">Follow Me</h4>
            <div className="flex px-1 gap-x-6">
              <a href="https://github.com/Gulfam619" target="_blank" rel="noopener noreferrer"><FaGithub size={26} className="text-black cursor-pointer" /></a>
              <a href="https://www.linkedin.com/in/gulfam-haider-861016291" target="_blank" rel="noopener noreferrer"><FaLinkedin size={28} className="text-[#3B82F6]  cursor-pointer" /></a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header